import { centralizedAuth as authWrapper } from '@cimpress/simple-auth-wrapper'

const auth = new authWrapper({
	clientID: '7g9zrcp9JoDig7JyxBmLK2HpohKCqg9q',
	redirectRoute: '',
	domain: 'cimpress.auth0.com',
	audience: 'https://api.cimpress.io/'
})

export default auth



// WEBPACK FOOTER //
// ./src/common/auth.js